<script setup>
const props = defineProps({
  warnings: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: 'Integrity warnings',
  },
})

const toneClass = (warning) => {
  const severity = String(warning?.severity || 'info').toLowerCase()
  if (severity === 'error' || severity === 'critical' || severity === 'high') return 'tone-error'
  if (severity === 'warning' || severity === 'medium') return 'tone-warning'
  return 'tone-info'
}
</script>

<template>
  <section class="warning-panel">
    <h3>{{ title }}</h3>
    <p v-if="!warnings.length" class="empty">No active warnings.</p>
    <ul v-else>
      <li v-for="(warning, index) in warnings" :key="warning?.message || `warning-${index}`" :class="toneClass(warning)">
        <strong>{{ warning?.severity || 'info' }}</strong>
        <span>{{ warning?.message || warning }}</span>
        <small>source: {{ warning?.source || 'unknown' }}</small>
        <small v-if="warning?.recoverable !== undefined">recoverable: {{ warning.recoverable ? 'yes' : 'no' }}</small>
        <small v-if="warning?.retryable !== undefined">retryable: {{ warning.retryable ? 'yes' : 'no' }}</small>
        <small v-if="warning?.correlation_ref">correlation: {{ warning.correlation_ref }}</small>
      </li>
    </ul>
  </section>
</template>

<style scoped>
.warning-panel { border: 1px solid #e5e7eb; border-radius: 8px; padding: 0.7rem; background: #fff; }
.warning-panel ul { margin: 0; padding-left: 1rem; display: grid; gap: 0.45rem; }
.warning-panel li { border-radius: 6px; padding: 0.45rem; display: grid; gap: 0.2rem; }
.tone-error { background: #fee2e2; color: #991b1b; }
.tone-warning { background: #fffbeb; color: #92400e; }
.tone-info { background: #eff6ff; color: #1d4ed8; }
.empty { color: #6b7280; }
</style>

